export default "__VITE_ASSET__572b5869__"